import { useLocalSearchParams } from 'expo-router';
import Head from 'expo-router/head';

import { LoyaltyRbiChannel } from '@fhs-legacy/frontend/src/generated/graphql-gateway';
import { Receipt } from '@fhs-legacy/frontend/src/pages/receipt';
import { RestaurantReceipt } from '@fhs-legacy/frontend/src/pages/receipt/restaurant-receipt';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function ReceiptPage() {
  const { orderChannel } = useLocalSearchParams<{ orderChannel: LoyaltyRbiChannel }>();
  return (
    <>
      <Head>
        <title>Receipt - Firehouse Subs</title>
      </Head>
      {orderChannel === LoyaltyRbiChannel.RESTAURANT ? <RestaurantReceipt /> : <Receipt />}
    </>
  );
}
